import styled, { css } from "styled-components";

const Message = styled.div`
  position: relative;
  margin-bottom: 15px;
  padding: 10px 20px;
  line-height: 1.5;
  word-wrap: break-word;
  border-radius: 16px;
  font-size: 13px;
  max-width: 85%;

  @media (min-width: 640px) {
    font-size: 14px;
    max-width: 75%;
  }

  p {
    margin: 0.5em 0;
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  strong {
    font-weight: 600;
  }

  ul, ol {
    margin: 0.5em 0;
    padding-left: 1.5em;
  }

  li {
    margin: 0.25em 0;
  }

  ${(props) =>
    props.sent
      ? css`
          align-self: flex-end;
          color: white;
          background: var(--sentColor);
        `
      : css`
          align-self: flex-start;
          color: rgba(255, 255, 255, 0.9);
          background: var(--receiveColor);
          border: 1px solid rgba(255, 255, 255, 0.1);
        `}
`;

export default Message;
